import { render, staticRenderFns } from "./TerminationInfo.vue?vue&type=template&id=33277a0b&scoped=true&"
import script from "./TerminationInfo.vue?vue&type=script&lang=js&"
export * from "./TerminationInfo.vue?vue&type=script&lang=js&"
import style0 from "./TerminationInfo.vue?vue&type=style&index=0&id=33277a0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33277a0b",
  null
  
)

export default component.exports